import { AiProcessingStat } from './AiProcessingStat';
import { useAiProcessingWidget } from './hooks/useAiProcessingWidget';

/**
 * Navbar AI-processing button: the stat button (ring + "to review" badge +
 * hover popover). Clicking opens the agentic panel on its Processing tab, where
 * the full queue lives. Composition root — logic is in `useAiProcessingWidget`.
 */
export function AiProcessingWidget() {
  const { stats, inProgressItems, readyItems, openProcessing } =
    useAiProcessingWidget();

  return (
    <AiProcessingStat
      onOpen={openProcessing}
      stats={stats}
      inProgressItems={inProgressItems}
      readyItems={readyItems}
    />
  );
}
